import CreateIcon from "@mui/icons-material/Create";
import PrintIcon from "@mui/icons-material/Print";
import { Divider } from "@mui/material";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import React, { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";
import { checkIsDeveloper } from "../utils/loginUser";
import SalesRecordPrintDialog from "./developer/SalesRecordPrintDialog";

const DeveloperMenu = (props) => {
  const { SelectMenu } = props;
  const navigate = useNavigate();
  const [salesPrintOpen, setSalesPrintOpen] = useState(false);
  const isDeveloper = checkIsDeveloper();
  if (!isDeveloper) {
    return null;
  }

  return (
    <Fragment>
      <Divider sx={{ mt: 15, textAlign: "center" }}>開発者</Divider>
      <List>
        <ListItemButton
          component="button"
          onClick={() => SelectMenu("/handwrite")}
        >
          <ListItemIcon>
            <CreateIcon />
          </ListItemIcon>
          <ListItemText primary="手書き認識" />
        </ListItemButton>

        <ListItemButton
          component="button"
          onClick={() => SelectMenu("/news_list")}
        >
          <ListItemIcon>
            <CreateIcon />
          </ListItemIcon>
          <ListItemText primary="お知らせ" />
        </ListItemButton>

        <ListItemButton
          component="button"
          onClick={() => SelectMenu("/user_list")}
        >
          <ListItemIcon>
            <CreateIcon />
          </ListItemIcon>
          <ListItemText primary="ユーザー管理" />
        </ListItemButton>

        <ListItemButton
          component="button"
          onClick={() => setSalesPrintOpen(true)}
        >
          <ListItemIcon>
            <PrintIcon />
          </ListItemIcon>
          <ListItemText primary="販売原票QR印刷" />
        </ListItemButton>
      </List>

      <SalesRecordPrintDialog
        open={salesPrintOpen}
        onClose={() => setSalesPrintOpen(false)}
      />
    </Fragment>
  );
};

export default DeveloperMenu;
